// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_CONFIRM_IDENTITY_IS_OPENED = 'confirm-identity/SET_CONFIRM_IDENTITY_IS_OPENED';
export const SET_INSECURE_ACTION = 'confirm-identity/SET_INSECURE_ACTION';
export const UNSET_INSECURE_ACTION = 'confirm-identity/UNSET_INSECURE_ACTION';
